export const classes = {
  menu: 'mt-1 p-1',
  headerWrapper: 'flex justify-end',
  sliderWrapper: 'w-[200px] mx-4 px-2 pb-1 flex flex-col justify-center',
  slider: 'w-full mx-0 py-0 mt-2',
  sliderLabel:
    'text-xs font-semibold text-grey-7 dark:text-mauve-2 tracking-wide',
  resetButton:
    'text-grey-7 dark:text-mauve-2 hover:text-grey-8 dark:hover:text-mauve-1 font-normal text-sm',
};
